<template>
  <v-card :class="fetchingPlayerLink ? 'py-0' : 'py-4'">
    <div v-if="fetchingPlayerLink === false">
      <v-alert class="mx-4 my-0" :type="alert.type" text dense border="left">
        {{ alert.message }}
      </v-alert>

      <v-card-text
        v-if="alert.type !== 'success'"
        :class="{
          'pt-0': $vuetify.breakpoint.mobile,
        }"
      >
        <v-form ref="form" v-model="form.valid" @submit="vinculatePlayer">
          <div class="subtitle-1 py-2">
            {{ $t("affiliatesPayments.insertPlayerAccount") }}
          </div>

          <div style="max-width: 600px;">
            <v-text-field
              class="mb-2"
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="form.login"
              label="Login"
              :rules="rules.loginRules"
              single-line
              hide-details="auto"
              prepend-icon="mdi-account-outline"
              solo-inverted
              clearable
            ></v-text-field>

            <v-text-field
              v-model="form.password"
              :append-icon="form.showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="form.showPassword ? 'text' : 'password'"
              :label="$t('password')"
              :rules="rules.passwordRules"
              @click:append="form.showPassword = !form.showPassword"
              hide-details="auto"
              solo-inverted
              clearable
              :counter="12"
              maxlength="12"
              prepend-icon="mdi-lock-outline"
            ></v-text-field>
            <v-card-actions class="py-4 px-0">
              <v-spacer></v-spacer>
              <v-btn
                color="info"
                type="submit"
                :disabled="!form.valid || loading"
                :loading="loading"
                @click.prevent="vinculatePlayer"
              >
                {{ $t("confirm") }}
              </v-btn>
            </v-card-actions>
          </div>
        </v-form>
      </v-card-text>
      <v-card v-else class="mx-4 my-4 pa-2" outlined>
        <div v-for="(value, key) in playerInfo" :key="key">
          <strong>{{ transformKey(key) }}:</strong>
          {{ value }}
          <br />
        </div>
      </v-card>
    </div>

    <v-skeleton-loader
      v-else
      type="image"
      class="mx-auto"
      height="fit-content"
    />
  </v-card>
</template>
<script>
import { validate } from "@/util/form-validate";

export default {
  data: () => ({
    form: {
      valid: false,
      login: "",
      password: "",
      showPassword: false,
    },
    rules: {
      loginRules: [validate.required],
      passwordRules: [validate.required],
    },
    alert: {
      message: "",
      type: "",
    },
    loading: false,
    fetchingPlayerLink: true,
    playerInfo: {},
  }),

  created() {
    this.fetchPlayerLink();
  },

  methods: {
    fetchPlayerLink() {
      this.fetchingPlayerLink = true;

      this.$axios
        .get("/agent/affiliates/hasBoundPlayer")
        .then((res) => {
          this.alert.type = res.data.dados.player_already_bound
            ? "success"
            : "info";

          this.alert.message = res.data.dados.player_already_bound
            ? this.$t("affiliatesPayments.successLink")
            : this.$t("affiliatesPayments.infoLink");

          if (res.data.dados.player_already_bound) {
            this.playerInfo = {
              player_id: res.data.dados.player_id,
              player_login: res.data.dados.player_login,
              player_name: res.data.dados.player_name,
            };
          }
        })
        .finally(() => {
          this.fetchingPlayerLink = false;
        });
    },
    vinculatePlayer() {
      if (this.loading) {
        return;
      }

      const body = {
        login: this.form.login,
        password: this.form.password,
        operator_code: this.$domain(),
      };

      this.loading = true;

      this.$axios
        .post(
          `/player/user/login?db_name=${this.$domain()}`,
          this.$formdata(body)
        )
        .then((res) => {
          this.$axios
            .post(
              "/agent/affiliates/bondPlayer",
              this.$formdata({ token: res.data.token_jwt })
            )
            .then((res) => {
              this.alert.type = "success";
              this.alert.message = res.data.messages;

              this.playerInfo = {
                player_id: res.data.dados.player_id,
                player_login: res.data.dados.player_login,
                player_name: res.data.dados.player_name,
              };
            });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    transformKey(key) {
      const map = {
        player_id: "Id",
        player_login: "Login",
        player_name: this.$t("name"),
      };

      return map[key] || null;
    },
  },
};
</script>
